var focusTimeout = false;

var dataTableSearchTimeout = false;

/* Only register a service worker if it's supported */
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js');
}


var Services = (function () {

  var callingForm;
  var dataTable;
  var dataTableResponsive;
  var horizontalScrollEvent;

  // formModal
  var handleModals = function () {
    $('form.form-modal button').click(function(ev) {
      ev.preventDefault();
      callingForm = $(this).closest('form');
    })

    $('div.modal button.modal-delete-submit').click(function(ev) {
      ev.preventDefault();
      callingForm.submit();
    })
  }


  // Logout
  var handleUsers = function () {
    $('a#logout-link').click(function(ev) {
      ev.preventDefault();
      $('form#form-logout').submit();
    })
  }

  var handleForms = function () {
    $('a.add-timestamp').click(function(ev) {
        ev.preventDefault();
        var target = $(this).data('target');
        var element = $('[name="' + target + '"]')

        var sep = ""
        if (element.val() !== "") {
            sep = "\n\n"
        }

        element.val(element.val() + sep + moment().format('DD-MM-YYYY HH:mm:ss') + " ")
    })
  }

  // Forms
  var forms = function () {
    var $htmlOrBody = $('html, body'); // scrollTop works on <body> for some browsers, <html> for others

    var maxSMSLength = 160;
    $('.textarea-countdown-sms').keyup(function() {
      var length = $(this).val().length;
      var length = maxSMSLength-length;
      $('.textarea-characters-sms').text(length);
    });

    $('textarea').focus(function() {
      var $this = $(this);

      if(focusTimeout){
        clearTimeout(focusTimeout);
      }

      focusTimeout = setTimeout(function(){

        // get textarea's offset top position
        var textareaTop = $this.offset().top;

        var headerHeight = 60;
        var headerBottomHeight = $('.header-bottom').outerHeight(true);


        // scroll to the textarea
        $htmlOrBody.stop().scrollTop(textareaTop - (headerHeight + headerBottomHeight + 10));

      },3000)

    });

  }


  // dataTables
  var handleTables = function () {

    var defaultOpt = {
      scrollX:        true,
      scrollCollapse: true,
      fixedColumns:   {
        leftColumns: 2,
      },
      order: [],
      columnDefs: [ {
        targets: [ 1 ],
        orderData: [ 2, 3 ]
      } ],
      pageLength: 25,
      language: {
        search: "",
        searchPlaceholder: "Zoeken...",
        zeroRecords: "&nbsp;",
        lengthMenu: "Toon _MENU_ regels",
        emptyTable: "&nbsp;",
        info: "_START_ tot _END_ van _TOTAL_ resultaten",
        infoEmpty: "Geen resultaten om weer te geven",
        infoFiltered: "(gefilterd uit _MAX_ resultaten)",
        paginate: {
          first: '«',
          previous: '‹',
          next: '›',
          last: '»'
        },
        aria: {
          paginate: {
            first: 'Eerste',
            previous: 'Vorige',
            next: 'Volgende',
            last: 'Laatste'
          }
        }
      }
    };

    // Custom datatables
    var defaultOpt2 = {
      scrollX:        false,
      scrollCollapse: false,
      paging: false,
      order: [],
      columnDefs: [ {
        targets: [ 1 ],
        orderData: [ 2, 3 ]
      } ],
      pageLength: 25,
      language: {
        search: "",
        searchPlaceholder: "Zoeken...",
        zeroRecords: "&nbsp;",
        lengthMenu: "Toon _MENU_ regels",
        emptyTable: "&nbsp;",
        info: "_START_ tot _END_ van _TOTAL_ resultaten",
        infoEmpty: "Geen resultaten om weer te geven",
        infoFiltered: "(gefilterd uit _MAX_ resultaten)",
        paginate: {
          first: '«',
          previous: '‹',
          next: '›',
          last: '»'
        },
        aria: {
          paginate: {
            first: 'Eerste',
            previous: 'Vorige',
            next: 'Volgende',
            last: 'Laatste'
          }
        }
      },
      "fnDrawCallback": function( oSettings ) {


        if(dataTableSearchTimeout){
          clearTimeout(dataTableSearchTimeout)
        }

        dataTableSearchTimeout = setTimeout(function(){

          // sync - table header width fixed table header
          $('.fixed-vertical-header').remove();
          $('.fixed-vertical-area').remove();


          $('table.fixed-header-vertical thead th').css('width', 'auto');

          // clone default table header to fixed div
          $('table.fixed-header-vertical thead th').each(function(){

            var x = $(this).outerWidth(true);
            var thisClass = $(this).attr('class');

            $(this).width(x);
            $('.fixed-header-area table th').eq($(this).index()).css('width', x).attr('class', thisClass);

          });

          $('.fixed-header-area table').css('width', $('table.fixed-header-vertical').width());

          $(window).scroll();

        }, 200);



      }
    };
    // Custom datatables
    var defaultOpt2b = {
      scrollX:        false,
      scrollCollapse: false,
      paging: true,
      order: [],
      columnDefs: [ {
        targets: [ 1 ],
//        orderData: [ 2, 3 ]
      } ],
      pageLength: 25,
      language: {
        search: "",
        searchPlaceholder: "Zoeken...",
        zeroRecords: "&nbsp;",
        lengthMenu: "Toon _MENU_ regels",
        emptyTable: "&nbsp;",
        info: "_START_ tot _END_ van _TOTAL_ resultaten",
        infoEmpty: "Geen resultaten om weer te geven",
        infoFiltered: "(gefilterd uit _MAX_ resultaten)",
        paginate: {
          first: '«',
          previous: '‹',
          next: '›',
          last: '»'
        },
        aria: {
          paginate: {
            first: 'Eerste',
            previous: 'Vorige',
            next: 'Volgende',
            last: 'Laatste'
          }
        }
      },
      "fnDrawCallback": function( oSettings ) {
        if(dataTableSearchTimeout){
          clearTimeout(dataTableSearchTimeout)
        }

      }
    };

    // Responsive datatables
    var defaultOpt3 = {
      scrollX:        false,
      scrollCollapse: false,

      order: [],
      responsive: true,
      columnDefs: [ {
        targets: [ 1 ],
        orderData: [ 2, 3 ]
      } ],
      pageLength: 25,
      language: {
        search: "",
        searchPlaceholder: "Zoeken...",
        zeroRecords: "&nbsp;",
        lengthMenu: "Toon _MENU_ regels",
        emptyTable: "&nbsp;",
        info: "_START_ tot _END_ van _TOTAL_ resultaten",
        infoEmpty: "Geen resultaten om weer te geven",
        infoFiltered: "(gefilterd uit _MAX_ resultaten)",
        paginate: {
          first: '«',
          previous: '‹',
          next: '›',
          last: '»'
        },
        aria: {
          paginate: {
            first: 'Eerste',
            previous: 'Vorige',
            next: 'Volgende',
            last: 'Laatste'
          }
        }
      }
    };

    // Init datatables
    dataTable1 = $('.datatable').DataTable(defaultOpt);
    //dataTable2 = $('.datatable-custom').DataTable(defaultOpt2);
    dataTable2 = $('.datatable-custom').DataTable($.extend( defaultOpt2, { order: [[ 1, "asc" ]]} ));

    dataTableResponsive = $('.responsive-datatable').DataTable(defaultOpt3);
    dataTableObjects =  $('.datatable-objects').DataTable($.extend( defaultOpt2, { order: [[ 4, "asc" ], [ 5, "asc" ], [ 1, "asc" ]]} ));
    dataTableObjects2 =  $('.datatable-objects-2').DataTable($.extend( defaultOpt2b, {} ));

    // Fix to enable checkboxed
    $('.datatable, .responsive-datatable').on('click touch', '.form-check label', function(e){

      var $this = $(this);
      var $input = $this.parent().find('input');
      var checked = true;

      if($input.prop('checked')) {
        checked = false;
      }

      $input.prop('checked', checked);

      // check $input has id select-all
      if($input.attr('id') == 'select-all'){
        var rows = dataTable.rows({ 'search': 'applied' }).nodes();
        rows.each(function(){
          var inputID = $(this).find('input').attr('id');
          $('input[id="' + inputID + '"]').prop('checked', checked);
        });
      }

      e.stopPropagation();

    });

    // custom scroll horizontal function if keydown ctrl
    $(window).on('keydown', function(e) {
      if(e.keyCode === 17) {

        $("body").addClass('body--disable-scroll');

        $("#app").on('mousewheel', function(event, delta) {

          var scrollLeft =  $("body, html").scrollLeft();
          scrollLeft -= (delta * 30);

          $(window).scrollLeft(scrollLeft);

          event.preventDefault();
        });

      }
      else {
        $("body").removeClass('body--disable-scroll');
        $("#app").off('mousewheel');
      }

    });

    $(window).on('keyup', function(e) {
      if(e.keyCode === 17) {
        $("body").removeClass('body--disable-scroll');
        $("#app").off('mousewheel');
      }
    });


    // fixed header and address bar
    if($('table.fixed-header-vertical thead').length){


      // clone default table header to fixed div
      $('table.fixed-header-vertical thead th').each(function(){
        var x = $(this).outerWidth(true);
        $(this).width(x);
      });

      if($('.fixed-header-area').length == 0){
        $('<div class="fixed-header-area is-fixed disable-fixed"><table class="table table-striped nowrap table-bordered th-align-bottom" cellspacing="0" style="background:#fff;"><thead>' +  $("table.fixed-header-vertical thead").html() + '</thead></table></div>').insertBefore("table.fixed-header-vertical");
        $('.fixed-header-area table').css('width', $('table.fixed-header-vertical').width());
      }

      // init scroll
      $(window).scroll(function() {

        var scrollTopY = $(window).scrollTop();
        var scrollLeftX = $(window).scrollLeft();

        var dataTablesStartHeaderY = $('.fixed-header-vertical thead').offset().top;
        var dataTablesStartBodyY = $('.fixed-header-vertical tbody').offset().top;
        var dataTablesStartBodyX = $('.fixed-header-vertical tbody').offset().left;

        scrollLeftX = (0 - scrollLeftX);
        scrollTopY = (0 - scrollTopY) + dataTablesStartHeaderY;

        // fixed header
        $('.fixed-header-area table').css('margin-left', scrollLeftX);
        if($(window).scrollTop()  > dataTablesStartHeaderY) {
          $('.fixed-header-area').removeClass('disable-fixed');
          $('body').addClass('fixed-header-datatables')
        }
        else {
          $('.fixed-header-area').addClass('disable-fixed');
          $('body').removeClass('fixed-header-datatables');
        }

        // fixed vertical
        if($(window).width() > 990){

          if($(window).scrollLeft()  == 0 || $(window).scrollLeft()  <= dataTablesStartBodyX) {
            $('.fixed-vertical-header').remove();
            $('.fixed-vertical-area').remove();
          }

          if($(window).scrollLeft()  > dataTablesStartBodyX) {

            if($('.fixed-vertical-area').length == 0){

              var verticalTableHeaderHtml = '';
              var verticalTableBodyHtml = '';

              $('table.fixed-header-vertical tr').each(function(){

                var $trow = $(this);
                var i = 0;

                var verticalTableHtml = '<tr>';

                $trow.find('td, th').each(function(){

                  var $tcell = $(this);

                  if(i < 2){

                    var x = $tcell.outerWidth(true);
                    var y = $tcell.outerHeight(true);

                    $cellEl = 'td'
                    if($trow.closest('thead').length){
                      $cellEl = 'th'
                    }

                    verticalTableHtml += '<' + $cellEl + ' style="width:' + x + 'px;height:' + y + 'px">' + $tcell.html() + '</' + $cellEl + '>';
                  }
                  else {
                    return true
                  }

                  i++;


                });

                verticalTableHtml += '</tr>';

                if($trow.closest('thead').length){
                  verticalTableHeaderHtml += verticalTableHtml;
                }
                else {
                  verticalTableBodyHtml += verticalTableHtml;
                }


              });

              $('<div class="fixed-vertical-header"><table class="table table-striped nowrap table-bordered th-align-bottom" cellspacing="0" style="background:#fff;"><thead>' + verticalTableHeaderHtml + '</thead>').insertBefore("table.fixed-header-vertical");
              $('<div class="fixed-vertical-area is-fixed disable-fixed"><table class="table table-striped nowrap table-bordered th-align-bottom" cellspacing="0" style="background:#fff;"><thead>' + verticalTableHeaderHtml + '</thead><tbody>' + verticalTableBodyHtml + '</tbody></table></div>').insertBefore("table.fixed-header-vertical");

            }

            $('.fixed-vertical-area').removeClass('disable-fixed');
            $('body').addClass('fixed-vertical-datatables');
          }
          else {
            $('.fixed-vertical-area').addClass('disable-fixed');
            $('body').removeClass('fixed-vertical-datatables');
          }

          $('.fixed-vertical-area table').css('margin-top', scrollTopY);

        }

      });

      // custom sort function on fixed header
      $('.fixed-header-area table th').on('click', function() {
        $('table.fixed-header-vertical thead th').eq($(this).index()).trigger('click');

        // sync classes table header
        $('.fixed-header-area table th').each(function(){
          $(this).attr('class', $('table.fixed-header-vertical thead th').eq($(this).index()).attr('class'));
        })

      });

    }

  }


  var handleLoginValidation = function () {
    // for more info visit the official plugin documentation:
    // http://docs.jquery.com/Plugins/Validation
    var form = $('#loginForm')

    form.validate({
      errorElement: 'span', // default input error message container
      errorClass: 'help-block help-block-error', // default input error message class
      focusInvalid: false, // do not focus the last invalid input
      ignore: '',  // validate all fields including form hidden input
      rules: {
        password: {
          minlength: 2,
          required: true
        },
        email: {
          required: true,
          email: true
        }
      },

      highlight: function (element) { // hightlight error inputs
        $(element)
          .closest('.form-group .form-control').addClass('is-invalid') // set invalid class to the control group
      },
      unhighlight: function (element) { // revert the change done by hightlight
        $(element)
          .closest('.form-group .form-control').removeClass('is-invalid') // set invalid class to the control group
          .closest('.form-group .form-control').addClass('is-valid') // set valid class to the control group
      },
      success: function (label) {
        label
          .closest('.form-group .form-control').removeClass('is-invalid') // set success class to the control group
      }
    })
  }

  $('input[name="reason"]').blur(function(ev) {
    ev.preventDefault();
    $(this).removeClass('is-invalid');
  })

  $('button.update-reason').click(function(ev) {
    ev.preventDefault();
    var form = $(this).closest('form');
    var input = form.find('input[name="reason"]');

    if (input.val() === '') {
      input.addClass('is-invalid');
      input.focus();
    } else {
      form.submit();
    }
  })

  $('.window-blank').click(function(e) {
    var $this = $(this);
    window.open($this.attr('href'), "_blank", "status=1,toolbar=1,resizable=1,scrollbars=1,top=0,left=0");
    e.preventDefault();
  })



  return {
    // main function to initiate the module
    init: function () {
      handleForms()
      handleModals()
      handleUsers()
      handleTables()
      handleLoginValidation()
      //forms()
    }
  }
})()

jQuery(document).ready(function () {
  Services.init()
})
